// extracted by mini-css-extract-plugin
export var headingBox = "dropshadow-module--heading-box--8c60e";
export var offsetCards = "dropshadow-module--offset-cards--3c5d6";
export var removeTopMargin = "dropshadow-module--remove-top-margin--112ed";